import { INTERVENTION_TYPE_NON_DEFINI } from '@/configuration/logistique/intervention/interventionConf';
import genererGuid from '@/services/general/genererGuid';

export default function genererDemandeInterventionType() {
  return {
    sujet: '',
    ordreRealisation: 1,
    typeDemande: INTERVENTION_TYPE_NON_DEFINI,
    typeOtId: null,
    produitId: null,
    selected: false,
    id: genererGuid(),
    isCreate: true,
  };
}
